<div class="grid">
    <div class="col-12">
        <div>
        </div>
    </div>
</div>